import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatNumber(n: number): string {
  return n.toLocaleString("he-IL")
}

// Media assets (photos, video, …) live in the `elhadegel-web-assets` R2 bucket,
// never in the repo. The public base URL is configurable via VITE_ASSETS_BASE_URL
// (set in the Cloudflare Pages env); the fallback is the bucket's r2.dev domain.
const ASSETS_BASE =
  import.meta.env.VITE_ASSETS_BASE_URL ??
  "https://pub-badf355a67234996a5287438d37bd722.r2.dev"

export function assetUrl(path: string): string {
  return `${ASSETS_BASE}/${path.replace(/^\/+/, "")}`
}
